// Build-time feature flags (see frontend/.env.production).
//
// Absence of a variable preserves current behavior: streams ON, mining ON,
// vanilla home OFF. This keeps machine-generated env files
// (scripts/generate-frontend-env.ts, simulator/src/uiServer.ts) working
// without changes — they don't emit these vars, so committed values in
// .env.production apply and dev/simulator runs get the defaults.
//
// One-off overrides work via shell env, e.g.:
//   VITE_FEATURE_MINING=false npm run build

const streams = import.meta.env.VITE_FEATURE_STREAMS !== "false"
const mining = import.meta.env.VITE_FEATURE_MINING !== "false"

export const FEATURES = {
  streams,
  mining,
  // The default landing page is Streams-focused, so when Streams is off
  // "/" falls back to the vanilla WELEPHANT home even if unset.
  vanillaHome: import.meta.env.VITE_VANILLA_HOME === "true" || !streams,
} as const

export type FeatureKey = "streams" | "mining"
